import { TextStyle_TextAlignment } from "./../../../../ricos-schema/legacy/wix/rich_content/v1";
const indentLevelToClassName = {
  0: "indentZero",
  1: "indentOne",
  2: "indentTwo",
  3: "indentThree",
  4: "indentFour",
  5: "indentFive",
  6: "indentSix"
};
const alignmentToFlex = {
  [TextStyle_TextAlignment.LEFT]: "left",
  [TextStyle_TextAlignment.CENTER]: "center",
  [TextStyle_TextAlignment.RIGHT]: "right",
  [TextStyle_TextAlignment.JUSTIFY]: "flex-start"
};
export {
  alignmentToFlex,
  indentLevelToClassName
};
//# sourceMappingURL=consts.js.map
